module.exports = __webpack_public_path__ + "img/app-logo.dff07207.svg";